module.exports = __webpack_public_path__ + "static/media/galerija_2016 (15).33dc708b.jpg";